import { useAddOnFilter, useSetAddOnFilter } from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const AddOnSearchInput = ({
  onBlur,
  autoFocus,
}: { onBlur?: () => void; autoFocus?: boolean } = {}) => {
  const { t } = useTranslation();
  const { data: filter } = useAddOnFilter();
  const { mutateAsync } = useSetAddOnFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('addOn.filter.searchPlaceholder')}
      onBlur={onBlur}
      autoFocus={autoFocus}
    />
  );
};
